(function(){
  var root=document.getElementById('diagnostic'); if(!root) return;
  var D=window.BLQ_DATA||{}, PRODUCTS=D.products||{}, OFFER=D.offer||{};
  var POSTED=!!window.BLQ_POSTED;
  var KEY='blq-diagnostic';

  var Q=[
    {id:'peau',q:'Votre peau, au quotidien',o:[
      ['seche','Elle tiraille','Surtout en fin de journée ou par temps froid'],
      ['grasse','Elle brille ou marque vite','Zone T, imperfections'],
      ['reactive','Elle rougit ou réagit facilement',''],
      ['equilibree','Elle est plutôt équilibrée','']]},
    {id:'souhait',q:'Ce que vous aimeriez améliorer',multi:2,o:[
      ['rides','Les ridules et la fermeté',''],
      ['yeux','Un regard qui paraît fatigué',''],
      ['eclat','Un teint terne',''],
      ['confort','La sécheresse, l\'inconfort',''],
      ['brillances','Les brillances, les imperfections','']]},
    {id:'yeux',q:'Vos yeux réagissent-ils facilement ?',o:[
      ['sensibles','Oui, ils larmoient ou réagissent avec certains produits',''],
      ['ok','Non, pas particulièrement','']]},
    {id:'experience',q:'Où en êtes-vous avec vos soins ?',o:[
      ['essaye','J\'ai essayé beaucoup de choses','Ma peau réagit souvent'],
      ['efficacite','Je veux plus d\'efficacité',''],
      ['naturel','Je cherche du naturel et du suisse',''],
      ['debut','Je commence une vraie routine','']]},
    {id:'texture',q:'La texture idéale pour vous',o:[
      ['legere','Légère, qui ne colle pas','Elle doit se faire oublier sous le maquillage'],
      ['riche','Riche et enveloppante',''],
      ['egal','Peu importe, du moment que ça marche','']]},
    {id:'age',q:'Votre âge',o:[
      ['moins-35','Moins de 35 ans',''],['35-44','35 à 44 ans',''],['45-54','45 à 54 ans',''],['55-plus','55 ans et plus','']]}
  ];

  var STEP={
    lotion:['Lotion au Bleuet','Sur un coton ou au creux des mains, pour préparer la peau.'],
    verveine:['Lotion Booster d\'éclat Verveine','Matin et soir, quelques pulvérisations pour préparer la peau.'],
    elixir:['Élixir Contour des Yeux','Une goutte sur le contour, en tapotant de l\'intérieur vers l\'extérieur.'],
    creme:['Crème de jour Edelweiss','Sur le visage et le cou, matin et soir.'],
    serum:['Sérum au Chanvre','En dernier : quelques gouttes scellent l\'hydratation.']
  };

  var PROFILS={
    regard:{nom:'Profil Regard',titre:'Le regard d\'abord',
      texte:'Le contour des yeux est la zone la plus fine du visage : c\'est souvent là que la fatigue se voit en premier. Votre rituel commence par un soin pensé pour elle, l\'Élixir primé aux European Natural Beauty Awards 2025, puis prend soin du reste du visage.',
      etapes:['elixir','creme'],produits:['elixir','creme']},
    equilibre:{nom:'Profil Équilibre',titre:'Une peau nette, sans l\'assécher',
      texte:'Une peau qui brille a besoin d\'équilibre, pas d\'être décapée. La Lotion Booster d\'éclat à la verveine prépare la peau et lui donne bonne mine, la Crème de jour Edelweiss l\'hydrate sans effet gras : elle pénètre vite et la peau ne brille pas.',
      etapes:['verveine','creme'],produits:['verveine','creme']},
    antiage:{nom:'Profil Anti-âge en douceur',titre:'Des actifs anti-âge, sans compromis sur le confort',
      texte:'Votre peau demande de l\'efficacité, mais pas au prix de l\'inconfort. Notre routine visage en trois gestes réunit l\'extrait d\'edelweiss et des formules testées sous contrôle dermatologique sur peaux sensibles.',
      etapes:['lotion','creme','serum'],produits:['kit']},
    hydratation:{nom:'Profil Confort',titre:'Votre peau a soif',
      texte:'Votre peau manque d\'eau plus que de soins. L\'ordre des gestes compte : la crème hydrate, le Sérum au Chanvre appliqué en dernier scelle l\'hydratation. La peau paraît plus souple, plus confortable, toute la journée.',
      etapes:['creme','serum'],produits:['creme','serum']},
    eclat:{nom:'Profil Éclat',titre:'Retrouver un teint lumineux',
      texte:'Un teint terne traduit souvent une peau fatiguée par son environnement. La Crème de jour Edelweiss, notre crème antioxydante, aide la peau à paraître plus lumineuse ; la Lotion au Bleuet la prépare à mieux recevoir le soin.',
      etapes:['lotion','creme'],produits:['lotion','creme']}
  };

  var INTRO={
    essaye:'Vous avez déjà essayé beaucoup de soins, et votre peau réagit souvent. Les nôtres sont testés sous contrôle dermatologique sur peaux sensibles : vous pouvez avancer sereinement.',
    efficacite:'Vous voulez des résultats visibles. Nos formules associent l\'extrait d\'edelweiss à des actifs choisis pour leur efficacité, documentée en laboratoire.',
    naturel:'Vous cherchez du naturel et du suisse. Nos soins sont fabriqués en Suisse, avec un edelweiss cultivé en Valais, à 1 500 m d\'altitude.',
    debut:'Vous commencez une vraie routine. Bonne nouvelle : la vôtre tient en quelques gestes simples.'
  };
  var YEUX='Vos yeux réagissent facilement : l\'Élixir a été testé sous contrôle dermatologique et ophtalmologique.';
  var TEXTURE={
    legere:'Les textures de votre rituel pénètrent vite et ne collent pas : le maquillage se pose facilement par-dessus.',
    riche:'Envie de plus de confort ? Le soir, ajoutez quelques gouttes de Sérum au Chanvre après la crème.'
  };

  if(OFFER&&OFFER.titre){
    var om=root.querySelector('.blq-offer-meta'); om.hidden=false; om.lastChild.textContent=OFFER.titre;
    var g=root.querySelector('.blq-gift'); g.hidden=false; g.lastChild.textContent='Avec votre rituel : '+OFFER.titre.charAt(0).toLowerCase()+OFFER.titre.slice(1);
  }
  var state={i:0,a:{}};
  function load(){try{var s=JSON.parse(sessionStorage.getItem(KEY));if(s&&s.a)state=s;}catch(e){}}
  function save(){try{sessionStorage.setItem(KEY,JSON.stringify(state));}catch(e){}}

  function has(a,k){return (a.souhait||[]).indexOf(k)>-1;}
  function profil(a){
    if(has(a,'yeux')||a.yeux==='sensibles') return 'regard';
    if(has(a,'brillances')||a.peau==='grasse') return 'equilibre';
    if(has(a,'rides')) return 'antiage';
    if(has(a,'eclat')) return 'eclat';
    if(a.peau==='reactive' && a.age!=='moins-35') return 'antiage';
    return 'hydratation';
  }

  function show(name){
    root.querySelectorAll('.blq-step').forEach(function(s){s.hidden=s.dataset.step!==name;});
    state.view=name; save();
    if(name!=='intro'){var top=root.getBoundingClientRect().top+window.scrollY-80; if(window.scrollY>top) window.scrollTo({top:top});}
  }

  function renderQ(){
    var q=Q[state.i], st=root.querySelector('[data-step="quiz"]');
    st.querySelector('.blq-prog').innerHTML=Q.map(function(_,k){return '<i class="'+(k<=state.i?'on':'')+'"></i>';}).join('');
    st.querySelector('.blq-count').textContent='Question '+(state.i+1)+' sur '+Q.length;
    st.querySelector('.blq-q').textContent=q.q;
    var box=st.querySelector('.blq-opts'); box.innerHTML='';
    var nx=st.querySelector('[data-act="next"]'), hint=st.querySelector('.blq-hint');
    hint.hidden=!q.multi; if(q.multi) hint.textContent=q.multi+' choix maximum';
    function sync(){ var n=(state.a[q.id]||[]).length; nx.hidden=!q.multi||n===0; }
    q.o.forEach(function(o){
      var cur=state.a[q.id], on=q.multi?(cur||[]).indexOf(o[0])>-1:cur===o[0];
      var b=document.createElement('button'); b.type='button'; b.className='blq-opt'+(on?' sel':''); b.setAttribute('role','listitem'); b.setAttribute('aria-pressed',on?'true':'false'); b.setAttribute('data-k',o[0]);
      b.innerHTML='<b></b><span>'+o[1]+(o[2]?'<small>'+o[2]+'</small>':'')+'</span>';
      b.onclick=function(){
        if(q.multi){ var arr=(state.a[q.id]||[]).slice(), k=arr.indexOf(o[0]);
          if(k>-1){arr.splice(k,1);b.classList.remove('sel');b.setAttribute('aria-pressed','false');}
          else{ if(arr.length>=q.multi){var first=arr.shift(); var fb=box.querySelector('[data-k="'+first+'"]'); if(fb){fb.classList.remove('sel');fb.setAttribute('aria-pressed','false');}}
            arr.push(o[0]);b.classList.add('sel');b.setAttribute('aria-pressed','true');}
          state.a[q.id]=arr; save(); sync();
        } else { state.a[q.id]=o[0]; b.classList.add('sel'); setTimeout(next,220); }
      };
      box.appendChild(b);
    });
    sync();
    show('quiz'); st.querySelector('.blq-q').focus({preventScroll:true});
  }

  function next(){ if(state.i<Q.length-1){state.i++;renderQ();} else gate(); }

  function gate(){
    var p=profil(state.a); state.profil=p;
    root.querySelector('.blq-gate-name').textContent=PROFILS[p].nom;
    var tags=['quiz-peau','profil-'+p,'peau-'+state.a.peau,'yeux-'+state.a.yeux,'experience-'+state.a.experience,'texture-'+state.a.texture,'age-'+state.a.age].concat((state.a.souhait||[]).map(function(s){return 'souhait-'+s;}));
    root.querySelector('#blq-tags').value=tags.join(', ');
    show('gate');
  }

  function money(c){return 'CHF '+(c/100).toFixed(2);}
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}

  function result(){
    var P=PROFILS[state.profil||profil(state.a)];
    root.querySelector('.blq-r-title').textContent=P.titre;
    var lines=[INTRO[state.a.experience], P.texte];
    if(state.a.yeux==='sensibles' && P.etapes.indexOf('elixir')>-1) lines.push(YEUX);
    if(TEXTURE[state.a.texture] && !(state.a.texture==='riche' && P.etapes.indexOf('serum')>-1)) lines.push(TEXTURE[state.a.texture]);
    root.querySelector('.blq-r-text').innerHTML=lines.filter(Boolean).map(function(t){return '<p>'+esc(t)+'</p>';}).join('');
    function ok(k){var p=PRODUCTS[k]; return !(p===null || (p && p.available===false));}
    root.querySelector('.blq-steps').innerHTML=P.etapes.filter(ok).map(function(k,n){
      return '<li><em>0'+(n+1)+'</em><div><strong>'+STEP[k][0]+'</strong><span>'+STEP[k][1]+'</span></div></li>';}).join('');
    root.querySelector('.blq-cards').innerHTML=P.produits.map(function(k){
      var p=PRODUCTS[k]; if(!p||p.available===false) return '';
      var img=p.featured_image?'<img src="'+esc(p.featured_image)+(p.featured_image.indexOf('?')>-1?'&':'?')+'width=500" alt="'+esc(p.title)+'" loading="lazy">':'<span class="blq-sq"></span>';
      var url=p.url||('/products/'+p.handle);
      var v=p.variants&&p.variants[0]&&p.variants[0].available!==false?p.variants[0].id:null;
      return '<div class="blq-card"><a href="'+esc(url)+'" class="img">'+img+'</a><div class="bd"><a href="'+esc(url)+'" class="t" style="color:inherit;text-decoration:none">'+esc(p.title)+'</a><span class="p">'+(typeof p.price==='number'?money(p.price):esc(p.price||''))+'</span><a class="go" href="'+esc(url)+'" style="color:inherit">Découvrir le soin</a>'+(v?'<button type="button" class="blq-btn blq-add" data-act="add" data-v="'+v+'">Ajouter au panier</button>':'')+'</div></div>';
    }).join('');
    var ob=root.querySelector('.blq-offer');
    if(OFFER&&OFFER.titre&&OFFER.code){ob.hidden=false; ob.querySelector('strong').textContent=OFFER.titre; ob.querySelector('.blq-code').textContent=OFFER.code;
      try{fetch('/discount/'+encodeURIComponent(OFFER.code),{credentials:'same-origin'}).catch(function(){});}catch(e){} }
    show('result'); root.querySelector('.blq-r-title').focus({preventScroll:true});
  }

  root.addEventListener('click',function(e){
    var a=e.target.closest('[data-act]'); if(!a) return;
    var act=a.dataset.act;
    if(act==='start'){state={i:0,a:{}};renderQ();}
    if(act==='back'){ if(state.view==='gate'){state.i=Q.length-1;renderQ();} else if(state.i>0){state.i--;renderQ();} else show('intro'); }
    if(act==='copy'){try{navigator.clipboard.writeText(OFFER.code).then(function(){a.textContent='Code copié';setTimeout(function(){a.textContent=OFFER.code;},1500);},function(){});}catch(err){}}
    if(act==='add'){a.disabled=true;a.textContent='Ajout…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:+a.dataset.v,quantity:1,properties:{}}),credentials:'same-origin'})
      .then(function(res){if(!res.ok)throw 0;window.location.href='/cart';})
      .catch(function(){a.disabled=false;a.textContent='Réessayer';});}
    if(act==='next'){next();}
    if(act==='restart'){state={i:0,a:{}};save();show('intro');}
  });

  var form=root.querySelector('#blq-form');
  form.addEventListener('submit',function(){ state.pending=true; save(); });

  load();
  if(state.pending && POSTED){ state.pending=false; state.done=true; result(); }
  else if(state.done){ result(); }
  else if(state.view==='gate' && state.profil){ gate(); }
})();